<template>
  <v-container> 
    <v-layout row wrap>
      <v-flex xs12 v-show="loading">
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>          
      </v-flex>
      <v-flex xs12 v-show="!loading">
        <v-card>          
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs8>
                  <v-combobox
                    v-model="report"
                    clearable
                    item-text="name"
                    item-value="id"
                    :items="reportList"
                    label="Wybierz raport"
                ></v-combobox>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card v-if="report">
          <v-card-text>
            <v-form>
            <v-layout wrap>
                <v-flex xs12 v-if="reportDetails != null && reportDetails.fields !=null">    
                  <v-layout wrap>              
                    <v-flex xs12 v-for="f in reportDetails.fields" :key="f.id">
                      <v-layout wrap>
                        <v-flex xs12 v-show="f.type == 0">
                          <v-text-field v-model="f.value" :label="f.label" :placeholder="f.placeholder"/>
                        </v-flex>                  
                        <v-flex xs12 v-show="f.type == 1">
                          <v-layout  wrap>
                            <v-flex xs12 v-show="!f.isBetween">
                              <v-menu
                                v-model="f.show_date"
                                :close-on-content-click="false"
                                :nudge-right="40"                                
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="f.value"
                                    :label="f.label"
                                    prepend-icon="fa-calendar-alt"
                                    readonly
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker v-model="f.value" @input="f.show_date = false"  no-title scrollable locale="pl-PL"></v-date-picker>
                              </v-menu>   
                            </v-flex>
                            <v-flex xs12 v-show="f.isBetween">
                              <v-layout  wrap>
                                <v-flex xs6>
                                  <v-menu
                                    v-model="f.show_date1"
                                    :close-on-content-click="false"
                                    :nudge-right="40"                                  
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="f.value"
                                        :label="f.label"
                                        prepend-icon="fa-calendar-alt"
                                        placeholder="Początek"
                                        readonly
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="f.value" @input="f.show_date1 = false"  no-title scrollable locale="pl-PL"></v-date-picker>
                                  </v-menu>                                    
                                </v-flex>
                                <v-flex xs6>
                                  <v-menu
                                    v-model="f.show_date2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"                                  
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        v-model="f.value2"
                                        :label="f.label"
                                        prepend-icon="fa-calendar-alt"
                                        readonly
                                        placeholder="Koniec"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="f.value2" @input="f.show_date2 = false"  no-title scrollable locale="pl-PL"></v-date-picker>
                                  </v-menu>                                    
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>                
                        </v-flex>                       
                        <v-flex xs12 v-show="f.type == 2">
                          <v-autocomplete v-model="f.value" :items="f.options" :label="f.label" :placeholder="f.placeholder"></v-autocomplete>
                        </v-flex>                       
                        <v-flex xs12 v-show="f.type == 4">
                        </v-flex>                                                                    
                      </v-layout>
                    </v-flex>    
                  </v-layout>                
                </v-flex>
                <v-flex xs12>
                  <v-layout justify-end>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="generateReport">Generuj</v-btn>
                  </v-layout>
                </v-flex>
              
            </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>    
</template>

<script>
import {  mapActions } from "vuex";
import { reportService } from "@/services/";
import swal from "sweetalert";
export default {
  name: "Reports",
  data() {
    return {
      loading: false,     
      report: null,  
      reportList: [],
      reportDetails: null
    }
  },
  methods: {
    ...mapActions("title", ["updateTitle"]),
    ...mapActions("alert", ["error", "success"]),
    fileDownload(data,filename,mime)
    {
        var blob = new Blob([data], {type: mime || 'application/octet-stream'});
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(blob, filename);
        }
        else {
            var blobURL = window.URL.createObjectURL(blob);
            var tempLink = document.createElement('a');
            tempLink.style.display = 'none';
            tempLink.href = blobURL;
            tempLink.setAttribute('download', filename); 
            
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank');
            }
            
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }
    },
    generateReport() {
      if(this.reportDetails != null)
      {
        this.loading = true
        
        if(this.reportDetails.fields != null)
        {
          
          for(let i=0; i< this.reportDetails.fields.length;i++)
          {
            let field = this.reportDetails.fields[i]
            if(field.allowEmpty)
                continue
            
            if(field.isBetween)
            {
              if(!field.value || !field.value2)
              {
                this.showError("Błędnie podany zakres dat dla: "+field.label)
                return
              }
            }
            else
            {
              if(!field.value)
              {
                this.showError("Nie podano wartości dla: "+field.label)
                return
              }
            }
          }
        }
        
        var data = {id: this.report.id, fields: []}
        this.reportDetails.fields.forEach(field=> {
          if(field.value)
            data.fields.push({id: field.id, value1: field.value, value2: field.value2})
        })
        
        reportService.generateReport(data).then(resp => {                   
          if(resp.data != null && resp.data.result != null)
          {
            let filename = resp.data.result.filename
            reportService.downloadReport(resp.data.result.token).then(resp=> {
              if(resp.data != null)
              {
                this.fileDownload(resp.data,filename,resp.data.type)
              } else 
              {
                throw 'Error'
              }             
              this.loading = false
            }).catch(e=> {
              console.log(e)
              this.loading = false
            })
          }
          else
          {
            this.loading = false
            throw 'error'            
          }
          
        }).catch(e =>{          
          if(e.response != null && e.response.data != null && e.response.data.error != null && e.response.data.error.message != null)
          {
            this.showError(e.response.data.error.message)
          }
          else
          {
            this.showError("Błąd generowania raportu.")
          }          
          this.loading = false
        })
      }
    },    
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false    
      });
    }
  },
  watch: {
    report: function() {
        this.loading = true        
        reportService.getReport(this.report.id).then(resp => {
          if(resp.data != null && resp.data.result != null)
          {
            this.reportDetails = resp.data.result
            
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
          this.error("Błąd pobierania informacji o raporcie.")
        })
    }
  },
  created() {
    this.updateTitle("Raporty");
    reportService.getAll().then( resp=> {
      
      if(resp.data != null && resp.data.result != null){
        this.reportList = resp.data.result
      }      
    }).catch(() => {
        this.error("Błąd pobierania raportów")
    })
    
  }, 
}
</script>

<style>

</style>
